// frontend/utils/branding.js
import { AppConfig } from "../config/appConfig";

export const branding = (text) => {
  if (!text) return text;
  return text.replace(
    /{AppConfig.projectName}|Zerobox|ZERObox|zerobox/gi,
    AppConfig.projectName
  );
};
